import { load } from './loader';
import * as gototoButton from './modules/gototopButton';
import * as figureScale from './modules/figureScale';
import * as noteClamp from './modules/noteClamp';
import * as mobileNotes from './modules/mobileNotes';
import * as lazyLoad from './modules/imageLazyload';

load([
  gototoButton,
  figureScale,
  noteClamp,
  mobileNotes,
  lazyLoad
]);
